const matchingCopy = (matching, formatAmount=(x => x), hostView) => {
  const parts = [ hostView ? 'Match' : `${matching.subject} has pledged a match` ]

  if (matching.user_limit) {
    parts.push(`up to ${formatAmount(matching.user_limit)} per donor`)

    if (matching.overall_limit)
      parts.push(`up to ${formatAmount(matching.overall_limit)} total`)
  }
  else if (matching.overall_limit)
    parts.push(`up to ${formatAmount(matching.overall_limit)}`)
  else
    parts.push('with no caps or end dates')

  if (matching.end_date)
    parts.push(`until ${matching.end_date}`)

  return parts.join(' ').concat('.')
}

export default matchingCopy
